module.exports = __webpack_public_path__ + "img/hq.1c746fe9.png";